import { Component, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilterMatchMode, LazyLoadEvent, MenuItem, SelectItem } from 'primeng/api';
import { Table } from 'primeng/table';
import { IGlobalSearchParam, ISearchGlobalFilter } from '../../../../app/shared/models/Global-Search.model';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { FormBuilder, FormControl, FormGroup, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { DVMSSystemAlertsService } from '../../services';
import { SharedService } from '../../../shared/services/shared.service';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { JwtService } from '../../../../app/auth/services';
import { User } from '../../../auth/models';
import { DatePipe } from '@angular/common';
import { ILookupCategory } from 'src/app/shared/models/lookup.model';
import { LookupCategory } from 'src/app/shared/enums/EnumsVMS';
import { IDvmsSystemAlert } from '../../models';
import * as fs from 'file-saver';


@Component({
  selector: 'app-dvms-system-alerts',
  templateUrl: './dvms-system-alerts.component.html',
  styleUrls: ['./dvms-system-alerts.component.css'],
  encapsulation: ViewEncapsulation.None,
  providers: [DialogService, ConfirmationService, MessageService]
})
export class DvmsSystemAlertsComponent implements OnInit {
  @ViewChild('startDate') startDatepicker;
  @ViewChild('endDate') endDatepicker;
  showTopFilters: boolean;
  showFilters: boolean;
  showSorting: boolean;
  matchModeOptions: SelectItem[];
  matchModeOptionsForDate: SelectItem[];
  matchModeOptionsForNumeric: SelectItem[];
  showAddRuleButton: boolean = false;
  oldSortField: string = 'createdOn';
  oldSortOrder: string = 'desc';
  sortField: string = 'createdOn';
  sortOrder: string = 'desc';
  appliedFilters: { field: string, matchMode: string, value: string }[] = [];
  pageNo: number = 1;
  pageSize: number = 10;
  oldPageNo: number = 1;
  oldPageSize: number = 10;
  totalRecords: number;
  loadEvent: LazyLoadEvent;
  filters;
  filterCondition: { fieldName: string; type: string; }[] = [];
  startSearch: boolean = false;
  dvmsSystemAlertsList;
  isSearchLoading: boolean = false;
  loading: boolean = false;
  dvmsSystemAlertSearchParam: IGlobalSearchParam;
  items: MenuItem[];
  isshowpaginator: boolean = true;
  statusValues: any;
  showToggle: boolean;
  selectedHasAvailableStatus: any;
  loggedInUserProfile: User;
  showAddRuleButtonCD: boolean = false;
  showAddRuleButtonMD: boolean = false;
  dvmsSystemAlertsSearchSpinner = 'dvmsSystemAlertsSearchSpinner';
  createdOnFilterValue: any;
  modifiedOnFilterValue: any;
  startDateFilterValue:any;
  endDateFilterValue:any;
  AddAlertsDialog: boolean = false;
  alertsForm: FormGroup;
  pageNames: ILookupCategory;
  public selectedPageNameId: Array<any> = [];
  alertPageNameSelected: boolean = false;
  alertPageNameId;
  systemAlertPageNames: ILookupCategory;
  selectedAlertPageName: any;
  selectedGridMenuItem: any = null;
  dialogTitle;
  buttonLabel;
  alertEditId;
  startDateOnEdit: Date;
  endDateOnEdit: Date;
  minDate: Date;
  maxDate: Date;
  createdOn:Date;
  alertPageNameEditId;
  createdBy;
  isAdd:boolean = true;
  endDate_Start: Date =  new Date();
  loadingSave:boolean = false;
  allColumns = [
    { value: 'action', header: 'Action' },
    { value: 'alertPageName', header: 'Alert Page' },
    { value: 'alertName', header: 'Alert Name' },
    // { value: 'alertTitle', header: 'Alert Title' },
    { value: 'alertMessage', header: 'Alert Message' },
    { value: 'startDate', header: 'Start Date & Time' },
    { value: 'endDate', header: 'End Date & Time' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modifed On' },
  ]

  selectedColumns = [
    { value: 'action', header: 'Action' },
    { value: 'alertPageName', header: 'Alert Page' },
    { value: 'alertName', header: 'Alert Name' },
    // { value: 'alertTitle', header: 'Alert Title' },
    { value: 'alertMessage', header: 'Alert Message' },
    { value: 'startDate', header: 'Start Date & Time' },
    { value: 'endDate', header: 'End Date & Time' },
    { value: 'isActive', header: 'Status' },
    { value: 'createdByName', header: 'Created By' },
    { value: 'createdOn', header: 'Created On' },
    { value: 'modifiedByName', header: 'Modified By' },
    { value: 'modifiedOn', header: 'Modifed On' },
  ]
  @ViewChild('dt2', { static: true }) table: any;
  constructor(
    public datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private dvmsSystemAlertsService: DVMSSystemAlertsService,
    private _fb: FormBuilder,
    private _router: Router,
    public sharedService: SharedService,
    private jwtService: JwtService,
    private messageService: MessageService,
  ) {
    this.showFilters = false;
    this.showSorting = false;
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
  }
  ngOnInit(): void {
    const date = new Date();
    var offset = -640; //Timezone offset for EST in minutes.
    var estDate = new Date(date.getTime() + offset*60*1000);
    console.log(estDate);
    this.getLoggedInUserProfile();
    this.checkViewPermission();
    this.dialogTitle='Add Alerts';
    this.buttonLabel ='Save';
    this.getAlertPageNames();
    this.items = [];
    //const today = new Date();
    this.minDate = new Date(estDate);
    console.log('min',this.minDate)
    this.maxDate = new Date(estDate);
    const customFilterName = "custom-equals";
    const notEquals = "not-equals";
    const dateAfter = "date-after";
    const dateBefore = "date-before";

    this.matchModeOptions = [
      { label: "Custom Equals", value: customFilterName },
      { label: "Starts With", value: FilterMatchMode.STARTS_WITH },
      { label: "Contains", value: FilterMatchMode.CONTAINS }
    ];

    this.matchModeOptionsForDate = [
      { label: "Equals", value: customFilterName },
      { label: "Not Equals", value: notEquals },
      { label: "Greater Than", value: dateAfter },
      { label: "Less Than", value: dateBefore },
    ];

    this.filterCondition = [
      { fieldName: "alertName", type: "basic" },
      { fieldName: "alertPageName", type: "basic" },
      { fieldName: "alertTitle", type: "basic" },
      { fieldName: "alertMessage", type: "basic" },
      { fieldName: "startDate", type: "date" },
      { fieldName: "endDate", type: "date" },
      { fieldName:"isActive",type:"dropdown"},
      { fieldName: "createdOn", type: "date" },
      { fieldName: "createdByName", type: "basic" },
      { fieldName: "modifiedOn", type: "date" },
      { fieldName: "modifiedByName", type: "basic" },
    ];

    this.getAllDVMSSystemAlertsList();
    
    this.statusValues = [
      { description: 'All', id: 'All' },
      { description: 'Active', id: 'Active' },
      { description: 'Inactive', id: 'Inactive' }
    ];
    this.dvmsSystemAlertsForm();
    this.checkEditPermission();
  }

  getLoggedInUserProfile() {
    this.loggedInUserProfile = this.sharedService.getLoggedInUserProfile();
  }

  bindShowToggle() {
    this.showToggle = (this.showToggle ? false : true)
  }

  showAndHideColumn(event) {
    this.selectedColumns = event.value;
  }

  isShowColumns(columnName) {
    var tempColumn = this.selectedColumns.filter(col => col.value == columnName);
    if (tempColumn.length == 1) {
      return true;
    }
    return false;
  }
  bindShowFilter() {
    this.showFilters = (this.showFilters ? false : true)
  }

  bindShowSorting() {
    this.showSorting = (this.showSorting ? false : true)
  }
  setColumnWidth(value) {
    if (this.showFilters == true && this.showSorting == true) {
      return value + 4 + 'rem'
    } else if (this.showFilters == true || this.showSorting == true) {
      return value + 2 + 'rem'
    }
    else {
      return value + 'rem'
    }
  }

  checkViewPermission() {
    var permission = this.jwtService.getLoggedInUserProfile();
    if (permission == 0) {
      this._router.navigateByUrl('/login');
    }
  }
  checkEditPermission()
  {
    var isAdminAdd = this.sharedService.checkPermission("Admin_Add");
    if (isAdminAdd) {
      var editItem = {
        label: 'Edit Alert',
        icon: 'pi pi-fw pi-pencil',
        command: e => this.editDvmsSystemAlerts(this.selectedGridMenuItem.alertId),
      }
      this.items.push(editItem);
    }
  }
  getAllDVMSSystemAlertsList() {

    this.appliedFilters.push({ field: "loggedInUserId", matchMode: "custom-equals", value: this.loggedInUserProfile.uid })


    this.dvmsSystemAlertSearchParam =
    {
      pageNo: this.pageNo,
      pageSize: this.pageSize,
      sortField: this.sortField,
      appliedFilters: this.appliedFilters,
      sortOrder: this.sortOrder
    };
    this.spinner.show(this.dvmsSystemAlertsSearchSpinner);
    this.dvmsSystemAlertsService.getAllDVMSSystemAlertsList(this.dvmsSystemAlertSearchParam).subscribe((data: any) => {
      //this.appliedFilters = [];
      this.dvmsSystemAlertsList = data;
      console.log(this.dvmsSystemAlertsList);
      this.totalRecords = (this.dvmsSystemAlertsList === null || this.dvmsSystemAlertsList === undefined || this.dvmsSystemAlertsList.length <= 0) ? 0 : data[0].totalCount;
      this.isshowpaginator = this.dvmsSystemAlertsList.length > 0 ? true : false;
      this.spinner.hide(this.dvmsSystemAlertsSearchSpinner);
    });
  }
  loadDVMSSystemAlerts(event: LazyLoadEvent) {
    //this.appliedFilters = [];
    this.loadEvent = event;
    if (event.first == 0) {
      this.pageNo = 1;
    }
    else {
      this.pageNo = (event.first / event.rows) + 1;
    }
    this.pageSize = event.rows;

    this.pageSize = event.rows;

    if ((this.oldPageNo != this.pageNo) || (this.oldPageSize != this.pageSize)) {
      this.applyFilter();
      this.getAllDVMSSystemAlertsList();
    }
    this.oldPageNo = this.pageNo;
    this.oldPageSize = this.pageSize;
    this.filters = event.filters;
    if (this.filters["createdOn"] != undefined) {
      if (this.filters["createdOn"][0].matchMode == "date-after") {
        this.showAddRuleButtonCD = true;
      }
      else {
        this.showAddRuleButtonCD = false;
      }
    }
    if (this.filters["modifiedOn"] != undefined) {
      if (this.filters["modifiedOn"][0].matchMode == "date-after") {
        this.showAddRuleButtonMD = true;
      }
      else {
        this.showAddRuleButtonMD = false;
      }
    }
    this.sortField = event.sortField;
    if (event.sortField === undefined || event.sortField === null) {
      this.sortField = 'createdOn';
    }
    if (event.sortOrder === 1) {
      this.sortOrder = 'desc';
    }
    if (event.sortOrder === -1) {
      this.sortOrder = 'asc';
    }
    if (this.oldSortField !== this.sortField || this.oldSortOrder !== this.sortOrder) {
      this.applyFilter();
      this.getAllDVMSSystemAlertsList()
    }
    this.oldSortField = this.sortField;
    this.oldSortOrder = this.sortOrder;
  }


  applyFilter() {
    if (Object.keys(this.filters).length > 1) {
      this.appliedFilters = [];
      for (let i = 0; i < this.filterCondition.length; i++) {
        if (this.filterCondition[i].type == "checkbox") {
          if (this.filters[this.filterCondition[i].fieldName][0].value == true) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: "true"
            })
          }
          else if (this.filters[this.filterCondition[i].fieldName][0].value == false) {
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: "false"
            })
          }
        }
        else if (this.filterCondition[i].type == "basic") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }

        else if (this.filterCondition[i].type == "date") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {

            if (this.filterCondition[i].fieldName == "createdOn") {
              this.dateFilterValueSet(this.createdOnFilterValue, "createdOn")
            }

            if (this.filterCondition[i].fieldName == "modifiedOn") {
              this.dateFilterValueSet(this.modifiedOnFilterValue, "modifiedOn")
            }
            if (this.filterCondition[i].fieldName == "startDate") {
              this.dateFilterValueSet(this.startDateFilterValue, "startDate")
            }

            if (this.filterCondition[i].fieldName == "endDate") {
              this.dateFilterValueSet(this.endDateFilterValue, "endDate")
            }
          }
        }

        else if (this.filterCondition[i].type == "numeric") {
          if (this.filters[this.filterCondition[i].fieldName][0].value !== null)
            this.appliedFilters.push({
              field: this.filterCondition[i].fieldName,
              matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
              value: this.filters[this.filterCondition[i].fieldName][0].value
            })
        }

        else if (this.filterCondition[i].type == "dropdown") {
          if (this.filters[this.filterCondition[i].fieldName] !== undefined) {
            if (this.filters[this.filterCondition[i].fieldName][0].value !== null && this.filters[this.filterCondition[i].fieldName][0].value != 0) {
              this.appliedFilters.push({
                field: this.filterCondition[i].fieldName,
                matchMode: this.filters[this.filterCondition[i].fieldName][0].matchMode,
                value: this.filters[this.filterCondition[i].fieldName][0].value
              })
            }
          }
        }
        // if(this.filters['alertPageName'] !==undefined)
        // {
        //   if (this.filters['alertPageName'][0].value !== null && this.filters['alertPageName'][0].value != 0) {
        //     this.getSelectedAlertPageName(this.systemAlertPageNames,this.filters['alertPageName'][0].value)
        //   }
        //   else{
        //     this.selectedAlertPageName= "";
        //   }
        // }
        if (this.filters['isActive'] !== undefined) {
          if (this.filters['isActive'][0].value !== null && this.filters['isActive'][0].value != 0) {
            this.getSelectedHasAvailableStatus(this.statusValues, this.filters['isActive'][0].value)
          }
          else {
            this.selectedHasAvailableStatus = "";
          }
        }
      }
    }

this.getAllDVMSSystemAlertsList();

  }

  clearFilter(table: Table) {
    for (let i = 0; i < this.filterCondition.length; i++) {
      if (this.table.filters[this.filterCondition[i].fieldName] != undefined) {
        this.table.filters[this.filterCondition[i].fieldName][0].value = null;
      }
    }
    table.clear();
    this.appliedFilters = [];
    this.selectedAlertPageName = [];
    this.createdOnFilterValue = undefined;
    this.modifiedOnFilterValue = undefined;
    this.startDateFilterValue = undefined;
    this.endDateFilterValue = undefined;
    this.selectedHasAvailableStatus = '';
    this.getAllDVMSSystemAlertsList();
  }

  applyFilterNew() {
    this.pageNo = 1;
    this.table.first = 0;
    this.applyFilter();
  }
  createdOnFilterData(e: any) {
    this.createdOnFilterValue = e;
    this.applyFilterNew();
  }
  modifiedOnFilterData(e: any) {
    this.modifiedOnFilterValue = e;
    this.applyFilterNew();
  }
  startDateFilterData(e:any){
    this.startDateFilterValue = e;
    this.applyFilterNew();
  }
  endDateFilterData(e:any){
    this.endDateFilterValue = e;
    this.applyFilterNew();
  }

  dateFilterValueSet(value, fieldName) {
    if (value !== undefined) {
      for (let j = 0; j < value.length; j++) {
        if (value[j].valueControl !== null) {
          this.appliedFilters.push({
            field: fieldName,
            matchMode: value[j].matchModeControl,
            value: this.datepipe.transform(value[j].valueControl, "MM-dd-yyyy")
          })
        }
      }
    }
  }
  getSelectedHasAvailableStatus(status, id) {
    if (id != null) {
      let tempStatus = status.filter(data => data.id == id);
      this.selectedHasAvailableStatus = tempStatus[0].description;
    } else {
      return "";
    }
  }
  getSelectedAlertPageName(status, id) {
    console.log('status',status);
    if (id != null) {
      let tempStatus = status.filter(data => data.lookupOrder == id);
      this.selectedAlertPageName = tempStatus[0].description;
    } else {
      return "";
    }
  }
getAlertPageNameSelected(pageId)
{
  this.sharedService.getLookupMasterByCategoryId(LookupCategory.DvmsSystemAlertDisplayPages).subscribe((data: any) => {
    
    for(var i=0;i<data.length;i++)
    {
      if(data[i].lookupOrder== pageId)
      this.selectedPageNameId=data[i]; 
    }
   
  });
 
}
  getAlertPageNames() {
    this.sharedService.getLookupMasterByCategoryId(LookupCategory.DvmsSystemAlertDisplayPages).subscribe((data: any) => {
      this.pageNames = data;
      this.systemAlertPageNames = data;
    });
  }
  
  getAlertPageNameOnChangeAdd(event) {
    if (event.value.length == 0) {
      //this.selectedItems = '“You may select multiple certifications.”';
      this.alertPageNameSelected  = false;
      this.alertPageNameId = '';
      this.alertPageNameEditId = '';
    }
    else {
      this.alertPageNameSelected  = true;
      if (event.value.length == 1) {
        this.alertPageNameId = event.value[0].lookupOrder;
      }
      else{
        this.alertPageNameId = "";
        for (var k = 0; k < event.value.length; k++) {
          if(k==0)
          {
            this.alertPageNameId = event.value[0].lookupOrder;
          }
          else{
            this.alertPageNameId = this.alertPageNameId + ',' + event.value[k].lookupOrder;
          }
          
        }
      }
    }
  }
  getAlertPageNameOnChangeEdit(event) {
    this.alertPageNameId = event.value.lookupOrder;
    this.alertPageNameSelected = true;

  }
  dvmsSystemAlertsForm() {
    this.alertsForm = this._fb.group({
      alertName: ['', [Validators.required]],
      startDate: ['', [Validators.required]],
      endDate: ['', [Validators.required]],
      isActive: [null],
      alertMessage: ['', [Validators.required]],
    });
  }
  get alertsFormControl() {
    return this.alertsForm.controls;
  }
  closeAlertsDialog() {
    this.dvmsSystemAlertsForm();
    this.startDatepicker.overlayVisible = false;
    this.endDatepicker.overlayVisible = false;
    this.alertEditId=undefined;
    this.selectedPageNameId=[];
  }
  onSelectStartDate(event)
  {
    var dt = new Date();
    var month = dt.getMonth();
    var year = dt.getFullYear();
    //var daysInMonth = new Date(year, month, 0).getDate();
    var daysInMonth = new Date(event.getFullYear()+1, event.getMonth()+1, 0).getDate();
    var currentDate = this.datepipe.transform(new Date(), 'yyyy-MM-dd');
    const localDateString = event.toLocaleDateString('En-en');
    //  console.log(localDateString);
     // this.timesheetEndDate_Start = new Date(this.datePipe.transform(localDateString, 'yyyy-MM-dd'));
      this.endDate_Start = new Date(localDateString);
   // this.timesheetEndDate_Start = new Date(this.datePipe.transform(event, 'yyyy-MM-dd'));
    var tmpEndDate = new Date(this.endDate_Start);
    // tmpEndDate.setDate( tmpEndDate.getDate() + 30 );
    tmpEndDate.setDate( tmpEndDate.getDate() + (daysInMonth-1) );
    this.alertsForm.controls['endDate'].setValue(undefined);
  }

  addSystemAlertDetails({ value }: { value: IDvmsSystemAlert }) {
    this.loadingSave = true;
    value.createdBy = Number(this.loggedInUserProfile.uid);
    value.modifiedBy = Number(this.loggedInUserProfile.uid);
    //value.alertPageId =this.alertPageNameId;
    value.startDateConvert=value.startDate.toLocaleString('en-US');
    value.endDateConvert=value.endDate.toLocaleString('en-US');

    console.log(value);
    value.alertPageIds = this.alertPageNameId;
    if(value.isActive == null)
    {
      value.isActive = false;
    }
    console.log(value.startDate);
    console.log(value.endDate);
    if (value.startDate != null) {
      var startDate = value.startDate.toDateString();
      console.log(startDate);
      let formatedstartDate = new Date(startDate);
      var strformat = formatedstartDate.toString();
      if (strformat.includes("India")) {
        formatedstartDate.setDate(formatedstartDate.getDate() + 1);
      }
      else {
        formatedstartDate.setDate(formatedstartDate.getDate());
      }
      value.startDate = (value.startDate === null) ? null : formatedstartDate;
    }
    if (value.endDate != null) {
      var endDate = value.endDate.toDateString();
      let formatedendDate = new Date(endDate);
      var strformat = formatedendDate.toString();
      if (strformat.includes("India")) {
        formatedendDate.setDate(formatedendDate.getDate() + 1);
      }
      else {
        formatedendDate.setDate(formatedendDate.getDate());
      }
      value.endDate = (value.endDate === null) ? null : formatedendDate;
    }
    console.log(value.startDate);
    console.log(value.endDate);
    if(this.alertEditId != undefined)
    {
      value.alertId = this.alertEditId;   
     //value.alertPageId =this.alertPageNameId;
     value.createdBy =  this.createdBy;
      value.createdOn = this.createdOn;
     value.alertPageIds =this.alertPageNameId;
      this.dvmsSystemAlertsService.updateDVMSSystemAlerts(Number(value.alertId),value).subscribe((data:any)=>{
        this.messageService.add({severity:'success', summary:'Confirmed', detail:'Alert updated successfully'});
        this.AddAlertsDialog=false;
        this.dvmsSystemAlertsForm();
        this.getAllDVMSSystemAlertsList();
        this.alertEditId=undefined;
        this.selectedPageNameId=[];
        this.loadingSave = false;
      });   
    }
    else{
      this.dvmsSystemAlertsService.addDVMSSystemAlerts(value).subscribe((data:any)=>{
        this.messageService.add({severity:'success', summary:'Confirmed', detail:'Alert created successfully'});
        this.AddAlertsDialog=false;
        this.selectedPageNameId=[];
        this.dvmsSystemAlertsForm();
        this.getAllDVMSSystemAlertsList();
        this.loadingSave = false;
      });
    }
  }
  addSystemAlert()
  {
    this.dvmsSystemAlertsForm();
    this.dialogTitle='Add Alerts';
    this.buttonLabel ='Save';
    this.isAdd = true;
  }
  editDvmsSystemAlerts(alertId:number)
  {
    this.dialogTitle='Edit Alert';
    this.buttonLabel ='Update';
    this.AddAlertsDialog = true;
    this.isAdd= false;
    this.alertPageNameSelected= true;
    this.dvmsSystemAlertsForm();
    this.dvmsSystemAlertsService.getDvmsSystemAlert(alertId).subscribe((data:any)=>{
      this.alertEditId = data.alertId;
      this.getAlertPageNameSelected(data.alertPageId);
      this.createdOn=data.createdOn;
      this.createdBy= data.createdBy;
      this.startDateOnEdit = data.startDate != null ? new Date(data.startDate) : null;
      this.endDateOnEdit = data.endDate != null ? new Date(data.endDate) : null;
      console.log(this.startDateOnEdit );
      this.alertPageNameId=data.alertPageId;
      this.alertsForm=this._fb.group({
        alertName: new FormControl(data.alertName, [Validators.required]),
        startDate: new FormControl(this.startDateOnEdit,[Validators.required]),
        endDate: new FormControl(this.endDateOnEdit,[Validators.required]),
        isActive: new FormControl(data.isActive),
        alertMessage: new FormControl(data.alertMessage, [Validators.required]),
      });

    });
  }
  exportDvmsSystemAlerts() {
    this.applyFilter();
    this.dvmsSystemAlertSearchParam = 
     {
      pageNo:this.pageNo,
      pageSize:this.pageSize,
      sortField:this.sortField,
      appliedFilters:this.appliedFilters,
      sortOrder:this.sortOrder
     };
     this.dvmsSystemAlertsService.ExportDvmsSystemAlertResult(this.dvmsSystemAlertSearchParam).subscribe(res => {
     var blob = new Blob([res.body], { type: res.body.type });
     const file = new File([blob],"DvmsSystemAlert.xlsx", { type: res.body.type });
     fs.saveAs(file);
     });
  }


}



